export class GeoBoundsDTO {
  constructor(public readonly minLat: number,
              public readonly minLong: number,
              public readonly maxLat: number,
              public readonly maxLong: number) {
  }
}
